const React = require("react");
const withState = require("../../../../../../utils/withState");
const ButtonAccept = require("../../../../../dumb/Button/Accept");
const {account$} = require("../../../../../../emitters/account");

const openPopupTfaSetUp = require('./utils/openPopupTfaSetUp');
const openPopupTfaDisable = require('./utils/openPopupTfaDisable');

module.exports = withState(() => {
  return (state) => {
    const tfaEnabled = state.account.tfa_enabled;
    const btnText = `${tfaEnabled ? 'Disable' : 'Set up'} 2FA`;
    const onClick = tfaEnabled
      ? openPopupTfaDisable
      : openPopupTfaSetUp;

    return (
      <ButtonAccept
        data-testid="btnChange2FA"
        onClick={onClick}
      >
        {btnText}
      </ButtonAccept>
    )
  }
}, {
  account: account$
})
